import { render } from "./m-good-road-item.vue?vue&type=template&id=888b74a0&ts=true"
import script from "./m-good-road-item.vue?vue&type=script&lang=ts"
export * from "./m-good-road-item.vue?vue&type=script&lang=ts"

import "./m-good-road-item.vue?vue&type=style&index=0&id=888b74a0&lang=scss"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__